<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/society.svg" style="width:20px" /> Owner
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="ownerItem"
            :fields="fields"
            table-filter
            items-per-page-select
            :items-per-page="5"
            pagination
            clickable-rows
            hover
            @row-clicked="rowClicked"
            caption="Breed"
          />
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/society.svg" style="width:20px" /> Owner Details
          </p>
        </CCardHeader>
     
          <CCard>
            <CCardBody>
              <CForm>
                <CInput label="Farmer Code" horizontal autocomplete="name" v-model="farmerId" />

                <CInput label="First Name" horizontal autocomplete="name" v-model="firstName" />
                <CInput label="	
Middle Name" horizontal autocomplete="name" v-model="middleName" />
                <CInput label="	
Last Name
" horizontal autocomplete="name" v-model="lastName" />

                <CInput label="Address" horizontal autocomplete="name" v-model="address" />
<div class="row">
  <div class="col-sm-4">State</div>
  <div class="col-sm-8"> <Vselect :options="second"  v-model="state" searchable /></div>
</div>
<br>
   <div class="row">
  <div class="col-sm-4">District</div>
  <div class="col-sm-8">   <Vselect :options="Districtoptions" v-model="district" searchable /></div>
</div>            
<br>
              
<div class="row">
  <div class="col-sm-4">Caste</div>
  <div class="col-sm-8">   <Vselect :options="second" v-model="caste" searchable />
</div>
</div> 
<br>
<div class="row">
  <div class="col-sm-4">Union</div>
  <div class="col-sm-8">   <Vselect :options="second" v-model="union" searchable />
</div>
</div> 

<br>
<div class="row">
  <div class="col-sm-4">Route</div>
  <div class="col-sm-8">   <Vselect :options="routeoption" v-model="route" searchable />
</div>
</div>
<br>
 <div class="row">
  <div class="col-sm-4">society</div>
  <div class="col-sm-8">     <Vselect :options="societyoption" v-model="society" searchable />
</div>
</div>              
<br>
               

              
                <CInput label="SAP Code" horizontal autocomplete="name" v-model="SAPCode" />
                <CInput label="Email" horizontal autocomplete="name" v-model="email" />

                <CInput
                  label="Phone No"
                  horizontal
                  autocomplete="phoneNumber"
                  v-model="phoneNumber"
                />

                <CInput
                  label="No Of Animal Registered"
                  horizontal
                  autocomplete="name"
                  v-model="noOfAnimimalRegistered"
                />
                <CRow>
                  <CCol sm="3">
                    <h5 style="font-size:15px">Status</h5>
                  </CCol>
                  <CCol sm="3">
                    <CSwitch
                      class="mx-1"
                      color="primary"
                      v-model="suspend"
                      checked
                      variant="opposite"
                      style="width:50px;float:left !important"
                      shape="pill"
                      v-bind="labelTxt"
                    />
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
            <CCardFooter>
              <CButton color="info" style="width:100px" v-if="addButton" @click="addSociety">
                <CIcon name="cilPencil" />&nbsp;Add
              </CButton>&nbsp;
              <CButton color="success" style="width:100px" v-if="saveButton" @click="updateRoute">
                <CIcon name="cilCheck" />&nbsp;Save
              </CButton>&nbsp;
              <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteRoute">
                <CIcon name="cilXCircle" />&nbsp;Delete
              </CButton>&nbsp;
              <CButton
                color="success"
                style="width:100px"
                v-if="EditsaveButton"
                @click="addSociety"
              >
                <CIcon name="cilCheck" />&nbsp;Save
              </CButton>&nbsp;
              <CButton
                color="secondary"
                style="width:100px"
                v-if="cancelButton"
                @click="CancelRoute"
              >
                <CIcon name="cilWarning" />&nbsp;Cancel
              </CButton>&nbsp;
              <CButton color="info" v-if="addnewButton" @click="addRouteplus">
                <CIcon name="cilPencil" />&nbsp;Add New
              </CButton>
            </CCardFooter>
          </CCard>
       
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { APIService } from "../../../apiservice.js";
import CTableWrapper from "../../tables/Table";
import Locationmap from "@/components";
import Dropdown from "vue-simple-search-dropdown";
import { Vselect } from "@/components";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper, Locationmap, Vselect },

  data() {
    return {
      routeItem: [],
      societyItem: [],
      districtsItem: [],
      second: [],
      unionoption: [],
      Stateoptions: [],
      Districtoptions: [],
      Casteoptions: [],
      routeoption: [],
      societyoption: [],
      ownerItem: [],
      owneredit: [],
      farmerId: null,
      SAPCode: "",
      email: "",
      phoneNumber: "",
      firstName: "",
      middleName: "",
      lastName: "",
      state:"",
      district:"",
      caste:"",
      union:"",
      route:"",
      society:"",
      address: "",
      noOfAnimimalRegistered: "",
      suspend: "",
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,

      labelTxt: {
        labelOn: "yes",
        labelOff: "no"
      },
      fields: [
        {
          key: "farmerId",
          sortable: true
        },
        {
          key: "SAPCode",
          sortable: true
        },
        {
          key: "email",
          sortable: true
        },
        {
          key: "mobileNumber",
          sortable: true
        },
        {
          key: "firstName",
          sortable: true
        },
        {
          key: "middleName",
          sortable: true
        },
        {
          key: "lastName",
          sortable: true
        },
        {
          key: "address",
          sortable: true
        },

        {
          key: "noOfAnimimalRegistered",
          sortable: true
        },
        {
          key: "suspend",
          sortable: true
        }
      ]
    };
  },
  methods: {
    getunionList() {
      APIService.unionList().then(res => {
        if (res.status == 200) {
          this.unionItem = res.data;
          // console.log("test1", this.unionItem);

          let value = this.unionItem.map(n => {
            return n.unionName;
          });

          this.second = value;
          // console.log("valuse", value);

          // for (let i in this.unionItem) {
          //   // this.unionoption.push(this.unionItem[i].unionName)
          //   // this.second.push(this.unionItem[i].unionName);
          //   console.log("test2", this.unionItem[i].unionName);
          //   this.second.push(this.unionItem[i].unionName);
          // }
          // console.log("test2",this.second)
        }
      });
    },
    getdistrictsList() {
      APIService.districtsList().then(res => {
        if (res.status == 200) {
          this.districtsItem = res.data;
          let value = this.districtsItem.map(n => {
            return n.districtName;
          });

          this.Districtoptions = value;
          // console.log("valuse", value);
        }
      });
    },
    getSocietyList() {
      let sus = [];
      APIService.societyList().then(res => {
        if (res.status == 200) {
          this.societyItem = res.data;
          let value = this.societyItem.map(n => {
            return n.soceityName;
          });

          this.societyoption = value;
          // console.log("valuse", value);
        }
      });
    },
    getRouteList() {
      APIService.routeList().then(res => {
        if (res.status == 200) {
          this.routeItem = res.data;
          // console.log("check",routeItem.suspend)
          let value = this.routeItem.map(n => {
            return n.routeName;
          });

          this.routeoption = value;
          console.log("valuse", value);
        }
      });
    },
    getFarmerList() {
      APIService.farmerList().then(res => {
        if (res.status == 200) {
          this.ownerItem = res.data;

this.farmerId = this.ownerItem[0].farmerId;
      this.SAPCode = this.ownerItem[0].SAPCode;
      this.mobileNumber = this.ownerItem[0].mobileNumber;
 this.state = this.ownerItem[0].state;
      this.district = this.ownerItem[0].district;
      this.caste = this.ownerItem[0].caste;
      this.union = this.ownerItem[0].union;
      this.route = this.ownerItem[0].route;
      this.society = this.ownerItem[0].society;
      this.email = this.ownerItem[0].email;
      this.firstName = this.ownerItem[0].firstName;
      this.middleName = this.ownerItem[0].middleName;
      this.lastName = this.ownerItem[0].lastName;
      this.address = this.ownerItem[0].address;
      this.noOfAnimimalRegistered = this.ownerItem[0].noOfAnimimalRegistered;
      this.suspend = this.ownerItem[0].suspend;



          // console.log("check", society.suspend);


            // this.owneredit = item;
      
        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.owneredit = item;
      this.farmerId = item.farmerId;
      this.SAPCode = item.SAPCode;
      this.mobileNumber = item.mobileNumber;
 this.state = item.state;
      this.district = item.district;
      this.caste = item.caste;
      this.union = item.union;
      this.route = item.route;
      this.society = item.society;
      this.email = item.email;
      this.firstName = item.firstName;
      this.middleName = item.middleName;
      this.lastName = item.lastName;
      this.address = item.address;
      this.noOfAnimimalRegistered = item.noOfAnimimalRegistered;
      this.suspend = item.suspend;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addSociety() {
      let farmerId = this.farmerId;
      let SAPCode = this.SAPCode;
      let mobileNumber = this.mobileNumber;

let state = this.state;
      let district = this.district;
      let caste = this.caste;
      let union = this.union;
      let route = this.route;
      let society = this.society;
     
      let email = this.email;
      let firstName = this.firstName;
      let middleName = this.middleName;
      let lastName = this.lastName;
      let address = this.address;
      let noOfAnimimalRegistered = this.noOfAnimimalRegistered;
      let suspend = this.suspend;
      let data = {
        farmerId,
        SAPCode,
        email,
        mobileNumber,
        firstName,
        middleName,
        lastName,
        state,
        district,
        caste,
        union,
        route,
        society,
        address,
        suspend,
        noOfAnimimalRegistered,
        suspend
      };
      APIService.saveFarmer(data).then(res => {
        if (res.status == 200) {
          this.farmerId = null;
          this.SAPCode = "";
          this.firstName = "";

 this.state = "";
          this.district = "";
          this.caste = "";
          this.union = "";
          this.route = "";
          this.society = "";



          this.email = "";
          this.mobileNumber = "";
          this.middleName = "";
          this.lastName = "";
          this.address = "";
          this.toTime = "";
          this.noOfAnimimalRegistered = "";
          this.suspend = "";
          this.getFarmerList();
            Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addRouteplus() {
      this.farmerId = null;
      this.SAPCode = "";
      this.firstName = "";
      this.email = "";
      this.middleName = "";
      this.mobileNumber = "";
      this.lastName = "";
      this.address = "";
      this.toTime = "";
      this.state = "";
          this.district = "";
          this.caste = "";
          this.union = "";
          this.route = "";
          this.society = "";
      this.noOfAnimimalRegistered = "";
      this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true)
      return getFarmerList();
    },

    CancelRoute() {
      this.farmerId = null;
      this.SAPCode = "";
      this.firstName = "";
      this.email = "";
      this.mobileNumber = "";
      this.middleName = "";
      this.lastName = "";
      this.address = "";
      this.toTime = "";
      this.state = "";
          this.district = "";
          this.caste = "";
          this.union = "";
          this.route = "";
          this.society = "";
      this.noOfAnimimalRegistered = "";
      this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false), this.getFarmerList();
    },
    updateRoute() {
      let id = this.owneredit._id;
      let farmerId = this.farmerId;
      let SAPCode = this.SAPCode;
      let mobileNumber = this.mobileNumber;
      let email = this.email;
      let firstName = this.firstName;
      let middleName = this.middleName;
      let lastName = this.lastName;
      let address = this.address;
      let state = this.state;
      let district = this.district;
      let caste = this.caste;
      let union = this.union;
      let route = this.route;
      let society = this.society;
      let noOfAnimimalRegistered = this.noOfAnimimalRegistered;
      let suspend = this.suspend;
      let value = {
        farmerId,
        SAPCode,
        email,
        mobileNumber,
        firstName,
        middleName,
        lastName,
        address,
        suspend,
        noOfAnimimalRegistered,
        suspend,
         state,
        district,
        caste,
        union,
        route,
        society
      };
      let data = { id, value };
      APIService.farmerUpdate(data).then(res => {
        if (res.status == 200) {
          this.farmerId = null;
          this.SAPCode = "";
          this.firstName = "";
          this.email = "";
          this.middleName = "";
          this.lastName = "";
          this.address = "";
          this.mobileNumber = "";
          this.noOfAnimimalRegistered = "";
          this.suspend = "";
          this.state = "";
          this.district = "";
          this.caste = "";
          this.union = "";
          this.route = "";
          this.society = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getFarmerList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteRoute() {

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})



  },
delete(){
   let id = this.owneredit._id;
      let data = { id };
      APIService.farmerDelete(data).then(res => {
        if (res.status == 200) {
          this.farmerId = null;
          this.SAPCode = "";
          this.firstName = "";
          this.email = "";
          this.middleName = "";
          this.lastName = "";
          this.address = "";
          this.mobileNumber = "";
          this.state = "";
          this.district = "";
          this.caste = "";
          this.union = "";
          this.route = "";
          this.society = "";
          this.noOfAnimimalRegistered = "";
          this.suspend = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getFarmerList();
        }
      });
    }
     
  },
  created() {
    this.getFarmerList();
    this.getunionList();
    this.getdistrictsList();
    this.getSocietyList();
    this.getRouteList();
  }
};
</script>
